import { Cloud } from '@cast/shared-types';
import { OmniAvailableInstance } from '@cast/types-omni';

export const availableInstancesMockData: OmniAvailableInstance[] = [
  {
    cloud: Cloud.aws,
    region: 'eu-west-2',
    availabilityZones: ['euw2-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.33333333333333337,
    spotTotalOperations: 3,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0.5,
    odPrice: 2.546,
    spotPrice: 0.368,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4dn.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az4', 'usw2-az2'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: 0.07692307692307687,
    spotTotalOperations: 13,
    spotIcEvents: 12,
    odIcEvents: 0,
    spotMortalityRate: 0.5,
    odPrice: 2.242,
    spotPrice: 1.6085833333333335,
    avgVcpu: 8,
    avgMemoryGb: 64,
    name: 'g6e.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az4', 'use1-az1', 'use1-az2', 'use1-az6'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 0.9636363636363636,
    odTotalOperations: 55,
    spotProvisioningRate: 1,
    spotTotalOperations: 4,
    spotIcEvents: 0,
    odIcEvents: 2,
    spotMortalityRate: 0.5,
    odPrice: 2.242,
    spotPrice: 1.13042,
    avgVcpu: 8,
    avgMemoryGb: 64,
    name: 'g6e.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3', 'usw2-az2', 'usw2-az1', 'usw2-az4'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: 0.3846153846153846,
    spotTotalOperations: 13,
    spotIcEvents: 8,
    odIcEvents: 0,
    spotMortalityRate: 0.3888888888888889,
    odPrice: 3.004,
    spotPrice: 1.532,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'g6e.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.736842105263158,
    odTotalOperations: 19,
    spotProvisioningRate: 0.1282051282051282,
    spotTotalOperations: 156,
    spotIcEvents: 136,
    odIcEvents: 5,
    spotMortalityRate: 0.375,
    odPrice: 1.212,
    spotPrice: 0.6140731707317073,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g5.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az2', 'use2-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 8,
    spotProvisioningRate: 1,
    spotTotalOperations: 7,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0.3,
    odPrice: 0.752,
    spotPrice: 0.2101111111111111,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4dn.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 99,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0.2,
    odPrice: 1.6239999999999999,
    spotPrice: 0.6818333333333333,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g5.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.3076923076923077,
    spotTotalOperations: 52,
    spotIcEvents: 36,
    odIcEvents: 0,
    spotMortalityRate: 0.19444444444444445,
    odPrice: 1.2040000000000002,
    spotPrice: 0.3971481481481482,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4dn.4xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.19999999999999996,
    spotTotalOperations: 5,
    spotIcEvents: 4,
    odIcEvents: 0,
    spotMortalityRate: 0.16666666666666666,
    odPrice: 0.707,
    spotPrice: 0.282,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g2-standard-4',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.9259259259259259,
    odTotalOperations: 27,
    spotProvisioningRate: 0.3783783783783784,
    spotTotalOperations: 37,
    spotIcEvents: 23,
    odIcEvents: 2,
    spotMortalityRate: 0.16666666666666666,
    odPrice: 1.212,
    spotPrice: 0.45985,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g5.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.38888888888888884,
    spotTotalOperations: 18,
    spotIcEvents: 11,
    odIcEvents: 0,
    spotMortalityRate: 0.16666666666666666,
    odPrice: 2.1759999999999997,
    spotPrice: 0.6800833333333333,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4dn.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.0714285714285714,
    spotTotalOperations: 14,
    spotIcEvents: 13,
    odIcEvents: 0,
    spotMortalityRate: 0.125,
    odPrice: 2.176,
    spotPrice: 0.6444,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4dn.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az2', 'aps1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 2,
    spotProvisioningRate: 0.6923076923076923,
    spotTotalOperations: 26,
    spotIcEvents: 8,
    odIcEvents: 0,
    spotMortalityRate: 0.11904761904761904,
    odPrice: 1.325,
    spotPrice: 0.5346875,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4dn.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.5,
    odTotalOperations: 2,
    spotProvisioningRate: 0.3157894736842105,
    spotTotalOperations: 19,
    spotIcEvents: 13,
    odIcEvents: 1,
    spotMortalityRate: 0.1111111111111111,
    odPrice: 2.94,
    spotPrice: 1.003277777777778,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g5.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az2', 'aps1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 17,
    spotProvisioningRate: 0.7037037037037037,
    spotTotalOperations: 27,
    spotIcEvents: 8,
    odIcEvents: 0,
    spotMortalityRate: 0.08823529411764706,
    odPrice: 0.828,
    spotPrice: 0.3337,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4dn.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.7808219178082192,
    spotTotalOperations: 73,
    spotIcEvents: 16,
    odIcEvents: 0,
    spotMortalityRate: 0.08191808191808192,
    odPrice: 1.212,
    spotPrice: 0.33541176470588235,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g5.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.6834862385321101,
    odTotalOperations: 218,
    spotProvisioningRate: 0.29323308270676696,
    spotTotalOperations: 133,
    spotIcEvents: 94,
    odIcEvents: 69,
    spotMortalityRate: 0.08095238095238096,
    odPrice: 1.006,
    spotPrice: 0.5538585858585858,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g5.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0.0625,
    odPrice: 0.805,
    spotPrice: 0.2125,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g6.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 1,
    odTotalOperations: 10,
    spotProvisioningRate: 0.9481481481481482,
    spotTotalOperations: 135,
    spotIcEvents: 7,
    odIcEvents: 0,
    spotMortalityRate: 0.061507936507936505,
    odPrice: 2.242,
    spotPrice: 0.6107058823529412,
    avgVcpu: 8,
    avgMemoryGb: 64,
    name: 'g6e.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.4903225806451613,
    spotTotalOperations: 155,
    spotIcEvents: 79,
    odIcEvents: 0,
    spotMortalityRate: 0.0606060606060606,
    odPrice: 2.4480000000000004,
    spotPrice: 0.8903285714285716,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g5.8xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 3,
    spotProvisioningRate: 0.33333333333333337,
    spotTotalOperations: 12,
    spotIcEvents: 8,
    odIcEvents: 0,
    spotMortalityRate: 0.05555555555555555,
    odPrice: 1,
    spotPrice: 0.399,
    avgVcpu: 12,
    avgMemoryGb: 48,
    name: 'g2-standard-12',
  },
  {
    cloud: Cloud.gcp,
    region: 'asia-south1',
    availabilityZones: ['2321', '2322', '2320'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 20,
    spotProvisioningRate: 0.045454545454545414,
    spotTotalOperations: 22,
    spotIcEvents: 21,
    odIcEvents: 20,
    spotMortalityRate: 0.047619047619047616,
    odPrice: 1.805,
    spotPrice: 0.721,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g2-standard-32',
  },
  {
    cloud: Cloud.gcp,
    region: 'asia-south1',
    availabilityZones: ['2321', '2320', '2322'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.13043478260869568,
    odTotalOperations: 23,
    spotProvisioningRate: 0.11111111111111116,
    spotTotalOperations: 9,
    spotIcEvents: 8,
    odIcEvents: 20,
    spotMortalityRate: 0.045454545454545456,
    odPrice: 1.041,
    spotPrice: 0.415,
    avgVcpu: 12,
    avgMemoryGb: 48,
    name: 'g2-standard-12',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.5607038123167156,
    odTotalOperations: 1705,
    spotProvisioningRate: 0.026022304832713727,
    spotTotalOperations: 269,
    spotIcEvents: 262,
    odIcEvents: 749,
    spotMortalityRate: 0.04383231945529635,
    odPrice: 1.734,
    spotPrice: 0.693,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g2-standard-32',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.3846153846153846,
    spotTotalOperations: 13,
    spotIcEvents: 8,
    odIcEvents: 0,
    spotMortalityRate: 0.04,
    odPrice: 0.8539999999999999,
    spotPrice: 0.341,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g2-standard-8',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.24675324675324672,
    odTotalOperations: 231,
    spotProvisioningRate: 0.0625,
    spotTotalOperations: 48,
    spotIcEvents: 45,
    odIcEvents: 174,
    spotMortalityRate: 0.038461538461538464,
    odPrice: 0.707,
    spotPrice: 0.28200000000000003,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g2-standard-4',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.2727272727272727,
    spotTotalOperations: 11,
    spotIcEvents: 8,
    odIcEvents: 0,
    spotMortalityRate: 0.037037037037037035,
    odPrice: 1.147,
    spotPrice: 0.45799999999999996,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g2-standard-16',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.9166666666666666,
    spotTotalOperations: 12,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: 0.03333333333333333,
    odPrice: 1.539,
    spotPrice: 0.19445454545454544,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'gr6.4xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.6962699822380107,
    odTotalOperations: 563,
    spotProvisioningRate: 0.7195767195767195,
    spotTotalOperations: 189,
    spotIcEvents: 53,
    odIcEvents: 171,
    spotMortalityRate: 0.032051282051282055,
    odPrice: 8.003,
    spotPrice: 3.194,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g2-standard-96',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: 0.7266187050359711,
    spotTotalOperations: 417,
    spotIcEvents: 114,
    odIcEvents: 0,
    spotMortalityRate: 0.030116550116550116,
    odPrice: 1.624,
    spotPrice: 0.49815909090909094,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g5.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 694,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0.027777777777777776,
    odPrice: 0.526,
    spotPrice: 0.2241743119266055,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4dn.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.4285714285714286,
    odTotalOperations: 21,
    spotProvisioningRate: 0.9022222222222223,
    spotTotalOperations: 225,
    spotIcEvents: 22,
    odIcEvents: 12,
    spotMortalityRate: 0.02327044025157233,
    odPrice: 1.624,
    spotPrice: 0.5125849056603774,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g5.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az2', 'use2-az1'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.9285714285714286,
    spotTotalOperations: 28,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0.021825396825396824,
    odPrice: 3.004,
    spotPrice: 0.7141904761904762,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'g6e.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 20,
    spotProvisioningRate: 0.5777777777777777,
    spotTotalOperations: 45,
    spotIcEvents: 19,
    odIcEvents: 0,
    spotMortalityRate: 0.020833333333333332,
    odPrice: 0.752,
    spotPrice: 0.2785681818181818,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4dn.2xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.5403094462540716,
    odTotalOperations: 2456,
    spotProvisioningRate: 0.3443396226415094,
    spotTotalOperations: 212,
    spotIcEvents: 139,
    odIcEvents: 1129,
    spotMortalityRate: 0.013689394761126206,
    odPrice: 0.854,
    spotPrice: 0.341,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g2-standard-8',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.9294117647058824,
    odTotalOperations: 255,
    spotProvisioningRate: 0.5625,
    spotTotalOperations: 32,
    spotIcEvents: 14,
    odIcEvents: 18,
    spotMortalityRate: 0.013057929724596394,
    odPrice: 0.9780000000000001,
    spotPrice: 0.5026694214876034,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g6.2xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.6646785950960901,
    odTotalOperations: 1509,
    spotProvisioningRate: 0.05128205128205132,
    spotTotalOperations: 234,
    spotIcEvents: 222,
    odIcEvents: 506,
    spotMortalityRate: 0.01295440615771585,
    odPrice: 1,
    spotPrice: 0.39899999999999997,
    avgVcpu: 12,
    avgMemoryGb: 48,
    name: 'g2-standard-12',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.6148097826086957,
    odTotalOperations: 1472,
    spotProvisioningRate: 0.06825938566552903,
    spotTotalOperations: 293,
    spotIcEvents: 273,
    odIcEvents: 567,
    spotMortalityRate: 0.012373192520251344,
    odPrice: 1.147,
    spotPrice: 0.458,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g2-standard-16',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 16,
    spotProvisioningRate: 1,
    spotTotalOperations: 105,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0.011440833824309677,
    odPrice: 0.526,
    spotPrice: 0.1585526315789474,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4dn.xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.7039030955585464,
    odTotalOperations: 743,
    spotProvisioningRate: 0.04195804195804198,
    spotTotalOperations: 143,
    spotIcEvents: 137,
    odIcEvents: 220,
    spotMortalityRate: 0.008620689655172414,
    odPrice: 4.001999999999999,
    spotPrice: 1.597,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g2-standard-48',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az4', 'use1-az1', 'use1-az2', 'use1-az6'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 2,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.9905437352245863,
    spotTotalOperations: 423,
    spotIcEvents: 4,
    odIcEvents: 0,
    spotMortalityRate: 0.005747126436781609,
    odPrice: 1.734,
    spotPrice: 0.6640689655172414,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4ad.8xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2234', '2233', '2231'],
    gpuType: 'nvidia-l4',
    gpuCount: 2,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.6995515695067265,
    odTotalOperations: 892,
    spotProvisioningRate: 0.031088082901554404,
    spotTotalOperations: 193,
    spotIcEvents: 187,
    odIcEvents: 268,
    spotMortalityRate: 0.0015649452269170577,
    odPrice: 2.0010000000000003,
    spotPrice: 0.7989999999999998,
    avgVcpu: 24,
    avgMemoryGb: 96,
    name: 'g2-standard-24',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az6', 'use1-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: 1,
    odTotalOperations: 48,
    spotProvisioningRate: 1,
    spotTotalOperations: 270,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0.00044853106077595876,
    odPrice: 0.867,
    spotPrice: 0.3682244897959184,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4ad.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.8,
    spotTotalOperations: 10,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 3.3970000000000002,
    spotPrice: 1.2583333333333333,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g6.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az3'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 4,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.336,
    spotPrice: 0.99,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4ad.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: null,
    spotPrice: 0.607,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az2', 'use2-az1'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 2,
    gpuMemoryMib: 98304,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.6125,
    spotTotalOperations: 80,
    spotIcEvents: 31,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: null,
    spotPrice: 0.8507142857142858,
    avgVcpu: 48,
    avgMemoryGb: 512,
    name: 'g7e.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az2'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 3,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.0839999999999999,
    spotPrice: 0.508,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4ad.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 4,
    spotIcEvents: 4,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.966,
    spotPrice: 0.5095,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g6.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az3', 'euw1-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 2,
    spotProvisioningRate: 0.6666666666666667,
    spotTotalOperations: 6,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.572,
    spotPrice: 1.3688,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g5.16xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'asia-south1',
    availabilityZones: ['2321', '2322', '2320'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.09999999999999998,
    odTotalOperations: 20,
    spotProvisioningRate: 0.1428571428571429,
    spotTotalOperations: 21,
    spotIcEvents: 18,
    odIcEvents: 18,
    spotMortalityRate: 0,
    odPrice: 1.194,
    spotPrice: 0.477,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g2-standard-16',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.125,
    spotTotalOperations: 8,
    spotIcEvents: 7,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.601999999999999,
    spotPrice: 2.546,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g6.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.6666666666666667,
    odTotalOperations: 6,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 2,
    spotMortalityRate: 0,
    odPrice: 1.455,
    spotPrice: 0.531,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g5.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.6153846153846154,
    spotTotalOperations: 13,
    spotIcEvents: 5,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.446,
    spotPrice: 0.9033333333333333,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'gr6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az1'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.6666666666666667,
    spotTotalOperations: 9,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 7.577,
    spotPrice: 1.006,
    avgVcpu: 64,
    avgMemoryGb: 512,
    name: 'g6e.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az2', 'euc1-az3'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.677,
    spotPrice: 0.2585,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4ad.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az2'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 15,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.8670000000000001,
    spotPrice: 0.361,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4ad.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.6666666666666667,
    odTotalOperations: 9,
    spotProvisioningRate: 0.6296296296296297,
    spotTotalOperations: 27,
    spotIcEvents: 10,
    odIcEvents: 3,
    spotMortalityRate: 0,
    odPrice: 5.672000000000001,
    spotPrice: 1.90804,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g5.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 189,
    spotProvisioningRate: 0,
    spotTotalOperations: 5,
    spotIcEvents: 5,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.752,
    spotPrice: 0.284797619047619,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4dn.2xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east1',
    availabilityZones: ['2231'],
    gpuType: 'nvidia-tesla-a100',
    gpuCount: 1,
    gpuMemoryMib: 38146,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 9,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 3.673,
    spotPrice: 1.804,
    avgVcpu: 12,
    avgMemoryGb: 85,
    name: 'a2-highgpu-1g',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.09090909090909094,
    spotTotalOperations: 11,
    spotIcEvents: 10,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.352,
    spotPrice: 1.206,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4dn.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az2', 'use2-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.8,
    spotTotalOperations: 10,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.204,
    spotPrice: 0.408,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4dn.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 33,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.867,
    spotPrice: 0.24369565217391306,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4ad.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az2', 'aps1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.6,
    spotTotalOperations: 5,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.7909999999999995,
    spotPrice: 1.5648,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4dn.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az3'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 4,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 6.811,
    spotPrice: 3.121,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g5.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.3109756097560976,
    spotTotalOperations: 164,
    spotIcEvents: 113,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 8.144,
    spotPrice: 3.3155454545454544,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g5.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 10,
    spotProvisioningRate: 0,
    spotTotalOperations: 4,
    spotIcEvents: 4,
    odIcEvents: 10,
    spotMortalityRate: 0,
    odPrice: 1.174,
    spotPrice: 0.4275,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g6.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.9523809523809523,
    spotTotalOperations: 21,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 13.35,
    spotPrice: 5.786285714285714,
    avgVcpu: 192,
    avgMemoryGb: 768,
    name: 'g6.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 3,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.446,
    spotPrice: 0.511,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'gr6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az6', 'use1-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 84,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.5409999999999999,
    spotPrice: 0.19183333333333333,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4ad.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.5714285714285714,
    spotTotalOperations: 7,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.446,
    spotPrice: 0.8069999999999999,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'gr6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.0714285714285714,
    spotTotalOperations: 14,
    spotIcEvents: 13,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.5390000000000001,
    spotPrice: 0.641,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'gr6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 11,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.379,
    spotPrice: 0.12514285714285714,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4ad.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az2', 'use2-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.7692307692307692,
    spotTotalOperations: 13,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.351999999999999,
    spotPrice: 0.963,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4dn.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.34782608695652173,
    spotTotalOperations: 23,
    spotIcEvents: 15,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.323,
    spotPrice: 0.7494999999999999,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az1'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 7.577,
    spotPrice: 2.252,
    avgVcpu: 64,
    avgMemoryGb: 512,
    name: 'g6e.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.978,
    spotPrice: 0.26,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g6.2xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'europe-west1',
    availabilityZones: ['2103'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.94,
    spotPrice: 0.347,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g2-standard-8',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az3', 'euw1-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 6,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.853,
    spotPrice: 1.2613333333333332,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4dn.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.8333333333333334,
    odTotalOperations: 6,
    spotProvisioningRate: 0.7333333333333334,
    spotTotalOperations: 15,
    spotIcEvents: 4,
    odIcEvents: 1,
    spotMortalityRate: 0,
    odPrice: 8.144,
    spotPrice: 2.3961111111111113,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g5.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az3'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.925,
    spotPrice: 0.547,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'gr6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 4,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 3.468,
    spotPrice: 1.348,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4ad.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 4,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.968,
    spotPrice: 0.441,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4ad.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2'],
    gpuType: 'T4',
    gpuCount: 4,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 18,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 3.912,
    spotPrice: 1.077,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g4dn.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az2', 'euc1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 3,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.658,
    spotPrice: 0.247,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4dn.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.25,
    spotTotalOperations: 12,
    spotIcEvents: 9,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.918,
    spotPrice: 1.6365,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g5.16xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'asia-south1',
    availabilityZones: ['2321', '2320', '2322'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 22,
    spotProvisioningRate: 0.5,
    spotTotalOperations: 2,
    spotIcEvents: 1,
    odIcEvents: 22,
    spotMortalityRate: 0,
    odPrice: 0.889,
    spotPrice: 0.354,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g2-standard-8',
  },
  {
    cloud: Cloud.aws,
    region: 'sa-east-1',
    availabilityZones: ['sae1-az1', 'sae1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.8,
    spotTotalOperations: 5,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.278,
    spotPrice: 0.1466,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4dn.2xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'asia-south1',
    availabilityZones: ['2321', '2322', '2320'],
    gpuType: 'nvidia-l4',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 24,
    spotProvisioningRate: 0.7272727272727273,
    spotTotalOperations: 11,
    spotIcEvents: 3,
    odIcEvents: 24,
    spotMortalityRate: 0,
    odPrice: 8.331,
    spotPrice: 3.323,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g2-standard-96',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 4,
    spotIcEvents: 4,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.323,
    spotPrice: 0.6026666666666667,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.09999999999999998,
    spotTotalOperations: 20,
    spotIcEvents: 18,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.539,
    spotPrice: 0.42783333333333334,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'gr6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.6,
    spotTotalOperations: 5,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.419,
    spotPrice: 1.0385,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 14,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: null,
    spotPrice: 0.47500000000000003,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g6.4xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 2,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 6,
    spotIcEvents: 6,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.0010000000000003,
    spotPrice: 0.799,
    avgVcpu: 24,
    avgMemoryGb: 96,
    name: 'g2-standard-24',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az4'],
    gpuType: 'T4g',
    gpuCount: 2,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 8,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.744,
    spotPrice: 0.412,
    avgVcpu: 64,
    avgMemoryGb: 128,
    name: 'g5g.metal',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-2',
    availabilityZones: ['euw2-az2'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 2,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 9,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.028,
    spotPrice: 0.345,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4ad.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 5,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.541,
    spotPrice: 0.14475,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4ad.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 4,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.90625,
    spotTotalOperations: 32,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 3.468,
    spotPrice: 0.7043333333333334,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4ad.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 3,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.805,
    spotPrice: 0.568,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g6.xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east4',
    availabilityZones: ['2270'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 120,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.143,
    spotPrice: 0.45699999999999996,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g2-standard-16',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az2'],
    gpuType: 'B300',
    gpuCount: 8,
    gpuMemoryMib: 275040,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: null,
    spotPrice: 17.915,
    avgVcpu: 192,
    avgMemoryGb: 4096,
    name: 'p6-b300.48xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'asia-south1',
    availabilityZones: ['2321', '2320', '2322'],
    gpuType: 'nvidia-l4',
    gpuCount: 2,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 20,
    spotProvisioningRate: 0,
    spotTotalOperations: 23,
    spotIcEvents: 23,
    odIcEvents: 20,
    spotMortalityRate: 0,
    odPrice: 2.083,
    spotPrice: 0.831,
    avgVcpu: 24,
    avgMemoryGb: 96,
    name: 'g2-standard-24',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 6,
    spotIcEvents: 6,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.002000000000001,
    spotPrice: 1.597,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g2-standard-48',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: 0.11111111111111116,
    spotTotalOperations: 9,
    spotIcEvents: 8,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.734,
    spotPrice: 0.693,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g2-standard-32',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.8888888888888888,
    odTotalOperations: 9,
    spotProvisioningRate: 0.9230769230769231,
    spotTotalOperations: 91,
    spotIcEvents: 7,
    odIcEvents: 1,
    spotMortalityRate: 0,
    odPrice: 4.096,
    spotPrice: 0.8270263157894737,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g5.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3', 'usw2-az2'],
    gpuType: 'T4g',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 84,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.3719999999999999,
    spotPrice: 0.47556,
    avgVcpu: 32,
    avgMemoryGb: 64,
    name: 'g5g.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.5,
    odTotalOperations: 8,
    spotProvisioningRate: 0.15000000000000002,
    spotTotalOperations: 20,
    spotIcEvents: 17,
    odIcEvents: 4,
    spotMortalityRate: 0,
    odPrice: 1.95,
    spotPrice: 0.66752,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g5.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az2', 'euc1-az3'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.3571428571428571,
    spotTotalOperations: 14,
    spotIcEvents: 9,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.47300000000000003,
    spotPrice: 0.11191666666666666,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4ad.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az2', 'use2-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.33333333333333337,
    spotTotalOperations: 3,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 3.397,
    spotPrice: 0.8565,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g6.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.5078534031413613,
    spotTotalOperations: 191,
    spotIcEvents: 94,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.096,
    spotPrice: 1.3454000000000002,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g5.16xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'uaenorth',
    availabilityZones: ['uaenorth-0'],
    gpuType: 'A10',
    gpuCount: 1,
    gpuMemoryMib: 4096,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 6,
    avgMemoryGb: 55,
    name: 'Standard_NV6ads_A10_v5',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az4'],
    gpuType: 'T4g',
    gpuCount: 2,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 10,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.744,
    spotPrice: 0.418,
    avgVcpu: 64,
    avgMemoryGb: 128,
    name: 'g5g.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az6'],
    gpuType: 'T4g',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.828,
    spotPrice: 0.235,
    avgVcpu: 16,
    avgMemoryGb: 32,
    name: 'g5g.4xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'europe-west3',
    availabilityZones: ['2302'],
    gpuType: 'nvidia-l4',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 9.432,
    spotPrice: 4.714,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g2-standard-96',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 10,
    spotProvisioningRate: 0.33333333333333337,
    spotTotalOperations: 3,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.978,
    spotPrice: 0.5694,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g6.2xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'asia-south1',
    availabilityZones: ['2321', '2320', '2322'],
    gpuType: 'nvidia-l4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 21,
    spotProvisioningRate: 0.10526315789473684,
    spotTotalOperations: 19,
    spotIcEvents: 17,
    odIcEvents: 21,
    spotMortalityRate: 0,
    odPrice: 4.1659999999999995,
    spotPrice: 1.662,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g2-standard-48',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'L40S',
    gpuCount: 4,
    gpuMemoryMib: 45776,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 4,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 10.493,
    spotPrice: 3.5345,
    avgVcpu: 48,
    avgMemoryGb: 384,
    name: 'g6e.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ca-central-1',
    availabilityZones: ['cac1-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 4,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 3.872,
    spotPrice: 0.698,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4ad.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az2', 'aps1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.3157894736842105,
    spotTotalOperations: 19,
    spotIcEvents: 13,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.395,
    spotPrice: 1.0103846153846154,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4dn.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3', 'usw2-az2'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: 1,
    spotTotalOperations: 4,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.526,
    spotPrice: 0.2266,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4dn.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 1,
    gpuMemoryMib: 98304,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 14,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: null,
    spotPrice: 1.0426666666666666,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'g7e.4xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-central1',
    availabilityZones: ['2000'],
    gpuType: 'nvidia-l4',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 6,
    spotIcEvents: 6,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 8.003,
    spotPrice: 3.194,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g2-standard-96',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 3,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 4.529,
    spotPrice: 1.475,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'g6e.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az3'],
    gpuType: 'L4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 5.526,
    spotPrice: 1.327,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g6.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 2,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 33,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.7340000000000002,
    spotPrice: 0.6106363636363636,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4ad.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az2'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 2,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 42,
    spotIcEvents: 42,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.1679999999999997,
    spotPrice: 0.267,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4ad.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.25,
    spotTotalOperations: 4,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.014,
    spotPrice: 0.882,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az2', 'euw1-az3', 'euw1-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.4375,
    odTotalOperations: 32,
    spotProvisioningRate: 0.33333333333333337,
    spotTotalOperations: 6,
    spotIcEvents: 4,
    odIcEvents: 18,
    spotMortalityRate: 0,
    odPrice: 1.353,
    spotPrice: 0.6354705882352941,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g5.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az2'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 5,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.579,
    spotPrice: 0.269,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4dn.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 4,
    gpuMemoryMib: 98304,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.33333333333333337,
    spotTotalOperations: 6,
    spotIcEvents: 4,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: null,
    spotPrice: 4.15475,
    avgVcpu: 96,
    avgMemoryGb: 1024,
    name: 'g7e.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.4917127071823204,
    spotTotalOperations: 181,
    spotIcEvents: 92,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 16.288,
    spotPrice: 6.3100499999999995,
    avgVcpu: 192,
    avgMemoryGb: 768,
    name: 'g5.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.7272727272727273,
    odTotalOperations: 11,
    spotProvisioningRate: 0.7209302325581395,
    spotTotalOperations: 43,
    spotIcEvents: 12,
    odIcEvents: 3,
    spotMortalityRate: 0,
    odPrice: 2.448,
    spotPrice: 0.688,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g5.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az6', 'use1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 15,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 0.805,
    spotPrice: 0.3846363636363636,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g6.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az6', 'use1-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 14,
    spotProvisioningRate: 0,
    spotTotalOperations: 5,
    spotIcEvents: 5,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.448,
    spotPrice: 1.017625,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g5.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 2,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 15,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 1.7340000000000002,
    spotPrice: 0.3885454545454545,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4ad.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3'],
    gpuType: 'T4g',
    gpuCount: 2,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: 0,
    odPrice: 2.744,
    spotPrice: 0.348,
    avgVcpu: 64,
    avgMemoryGb: 128,
    name: 'g5g.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'L4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 7,
    spotIcEvents: 7,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 6.675,
    spotPrice: 2.4244,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g6.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az4'],
    gpuType: 'T4g',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.5,
    spotTotalOperations: 2,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.372,
    spotPrice: 0.42,
    avgVcpu: 32,
    avgMemoryGb: 64,
    name: 'g5g.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az3'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.222,
    spotPrice: 0.452,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g6.2xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east4',
    availabilityZones: ['2271'],
    gpuType: 'nvidia-h100-80gb',
    gpuCount: 1,
    gpuMemoryMib: 76293,
    odProvisioningRate: 0,
    odTotalOperations: 4,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 4,
    spotMortalityRate: null,
    odPrice: 10.979,
    spotPrice: 2.756,
    avgVcpu: 26,
    avgMemoryGb: 234,
    name: 'a3-highgpu-1g',
  },
  {
    cloud: Cloud.azure,
    region: 'northeurope',
    availabilityZones: ['1', '3', '2'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 14,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 8,
    avgMemoryGb: 56,
    name: 'Standard_NC8as_T4_v3',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2'],
    gpuType: 'H200',
    gpuCount: 8,
    gpuMemoryMib: 144384,
    odProvisioningRate: 0,
    odTotalOperations: 280,
    spotProvisioningRate: 0,
    spotTotalOperations: 7,
    spotIcEvents: 7,
    odIcEvents: 280,
    spotMortalityRate: null,
    odPrice: 63.296,
    spotPrice: 21.621,
    avgVcpu: 192,
    avgMemoryGb: 2048,
    name: 'p5en.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ca-central-1',
    availabilityZones: ['cac1-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 2.716,
    spotPrice: 0.352,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'gr6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 8,
    gpuMemoryMib: 98304,
    odProvisioningRate: 0.9745762711864406,
    odTotalOperations: 1416,
    spotProvisioningRate: 0.5625,
    spotTotalOperations: 48,
    spotIcEvents: 21,
    odIcEvents: 36,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: 10.74,
    avgVcpu: 192,
    avgMemoryGb: 2048,
    name: 'g7e.48xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus',
    availabilityZones: ['1', '3', '2'],
    gpuType: 'A10',
    gpuCount: 1,
    gpuMemoryMib: 4096,
    odProvisioningRate: 1,
    odTotalOperations: 6,
    spotProvisioningRate: 1,
    spotTotalOperations: 2,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 6,
    avgMemoryGb: 55,
    name: 'Standard_NV6ads_A10_v5',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 1,
    odTotalOperations: 4,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 4.529,
    spotPrice: 1.6543333333333334,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'g6e.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ca-central-1',
    availabilityZones: ['cac1-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.709,
    spotPrice: 0.319,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'gr6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-north-1',
    availabilityZones: ['eun1-az3'],
    gpuType: 'A100',
    gpuCount: 8,
    gpuMemoryMib: 40960,
    odProvisioningRate: 1,
    odTotalOperations: 12,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: 7.447,
    avgVcpu: 96,
    avgMemoryGb: 1152,
    name: 'p4d.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az2'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 8,
    gpuMemoryMib: 98304,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 7,
    spotIcEvents: 7,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: 4.8756,
    avgVcpu: 192,
    avgMemoryGb: 2048,
    name: 'g7e.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 2,
    gpuMemoryMib: 98304,
    odProvisioningRate: 0.9865125240847784,
    odTotalOperations: 1557,
    spotProvisioningRate: 0.9531772575250836,
    spotTotalOperations: 299,
    spotIcEvents: 14,
    odIcEvents: 21,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: 2.326,
    avgVcpu: 48,
    avgMemoryGb: 512,
    name: 'g7e.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 4,
    gpuMemoryMib: 98304,
    odProvisioningRate: 0.9900559353635798,
    odTotalOperations: 1609,
    spotProvisioningRate: 0.9572368421052632,
    spotTotalOperations: 304,
    spotIcEvents: 13,
    odIcEvents: 16,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: 4.468,
    avgVcpu: 96,
    avgMemoryGb: 1024,
    name: 'g7e.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ca-central-1',
    availabilityZones: ['cac1-az2'],
    gpuType: 'Radeon Pro V520',
    gpuCount: 2,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.936,
    spotPrice: 0.358,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g4ad.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'L40S',
    gpuCount: 8,
    gpuMemoryMib: 45776,
    odProvisioningRate: 0.9919191919191919,
    odTotalOperations: 4950,
    spotProvisioningRate: 0.9462151394422311,
    spotTotalOperations: 502,
    spotIcEvents: 27,
    odIcEvents: 40,
    spotMortalityRate: null,
    odPrice: 30.130999999999997,
    spotPrice: 9.839333333333334,
    avgVcpu: 192,
    avgMemoryGb: 1536,
    name: 'g6e.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az1', 'usw2-az3', 'usw2-az2'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 3,
    spotProvisioningRate: 0.013986013986013957,
    spotTotalOperations: 143,
    spotIcEvents: 141,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 5.672000000000001,
    spotPrice: 2.2243,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g5.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az2', 'euw1-az3', 'euw1-az1'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 33,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 33,
    spotMortalityRate: null,
    odPrice: 6.332,
    spotPrice: 2.828333333333333,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g5.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2'],
    gpuType: 'Gaudi HL-205',
    gpuCount: 8,
    gpuMemoryMib: 32768,
    odProvisioningRate: 0,
    odTotalOperations: 382,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 382,
    spotMortalityRate: null,
    odPrice: 13.109,
    spotPrice: 7.724,
    avgVcpu: 96,
    avgMemoryGb: 768,
    name: 'dl1.24xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus',
    availabilityZones: ['1'],
    gpuType: 'Radeon Instinct MI25',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 16,
    avgMemoryGb: 56,
    name: 'Standard_NV16as_v4',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.323,
    spotPrice: 0.442,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az5', 'use1-az4', 'use1-az1', 'use1-az6'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 5,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.204,
    spotPrice: 0.41575,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4dn.4xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus2',
    availabilityZones: ['2'],
    gpuType: 'Radeon Instinct MI25',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 32,
    avgMemoryGb: 112,
    name: 'Standard_NV32as_v4',
  },
  {
    cloud: Cloud.gcp,
    region: 'europe-west4',
    availabilityZones: ['2342'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 1,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 1,
    spotMortalityRate: null,
    odPrice: 0.897,
    spotPrice: 0.417,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g2-standard-8',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-southeast-2',
    availabilityZones: ['apse2-az3', 'apse2-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 2,
    spotIcEvents: 2,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 5.659,
    spotPrice: 1.024,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4dn.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-2',
    availabilityZones: ['use2-az3', 'use2-az2', 'use2-az1'],
    gpuType: 'H200',
    gpuCount: 8,
    gpuMemoryMib: 144384,
    odProvisioningRate: 0,
    odTotalOperations: 73,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 73,
    spotMortalityRate: null,
    odPrice: 63.296,
    spotPrice: 12.059666666666667,
    avgVcpu: 192,
    avgMemoryGb: 2048,
    name: 'p5en.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1', 'euc1-az2', 'euc1-az3'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 0,
    odTotalOperations: 12,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 12,
    spotMortalityRate: null,
    odPrice: 2.804,
    spotPrice: 1.522,
    avgVcpu: 8,
    avgMemoryGb: 64,
    name: 'g6e.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az6'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 1,
    odTotalOperations: 19,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 3.0039999999999996,
    spotPrice: 1.1007272727272728,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'g6e.4xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus',
    availabilityZones: ['1', '2'],
    gpuType: 'Radeon Instinct MI25',
    gpuCount: 1,
    gpuMemoryMib: 4096,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 8,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 8,
    avgMemoryGb: 28,
    name: 'Standard_NV8as_v4',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus2',
    availabilityZones: ['2'],
    gpuType: 'Radeon Instinct MI25',
    gpuCount: 1,
    gpuMemoryMib: 2048,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 22,
    spotIcEvents: 22,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 4,
    avgMemoryGb: 14,
    name: 'Standard_NV4as_v4',
  },
  {
    cloud: Cloud.gcp,
    region: 'europe-west4',
    availabilityZones: ['2342'],
    gpuType: 'nvidia-l4',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 4,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 4,
    spotMortalityRate: null,
    odPrice: 8.412,
    spotPrice: 3.956,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g2-standard-96',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 2,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 0.838,
    spotPrice: 0.393,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g4dn.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-north-1',
    availabilityZones: ['eun1-az2', 'eun1-az3', 'eun1-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 30,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 0.5579999999999999,
    spotPrice: 0.19033333333333333,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4dn.xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'me-central2',
    availabilityZones: ['2600', '2601'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 6,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.601,
    spotPrice: 0.685,
    avgVcpu: 12,
    avgMemoryGb: 48,
    name: 'g2-standard-12',
  },
  {
    cloud: Cloud.azure,
    region: 'northeurope',
    availabilityZones: ['1'],
    gpuType: 'A10',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: 1,
    odTotalOperations: 17,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 12,
    avgMemoryGb: 110,
    name: 'Standard_NV12ads_A10_v5',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'H100',
    gpuCount: 8,
    gpuMemoryMib: 81920,
    odProvisioningRate: 0,
    odTotalOperations: 792,
    spotProvisioningRate: 0,
    spotTotalOperations: 17,
    spotIcEvents: 17,
    odIcEvents: 792,
    spotMortalityRate: null,
    odPrice: 55.04,
    spotPrice: 42.96543150684932,
    avgVcpu: 192,
    avgMemoryGb: 2048,
    name: 'p5.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az2'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 1,
    gpuMemoryMib: 98304,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 3,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: 0.8610000000000001,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'g7e.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-north-1',
    availabilityZones: ['eun1-az2', 'eun1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 32,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 0.854,
    spotPrice: 0.282,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g6.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az4', 'use1-az6'],
    gpuType: 'A100',
    gpuCount: 8,
    gpuMemoryMib: 81920,
    odProvisioningRate: 0.9838969404186796,
    odTotalOperations: 1242,
    spotProvisioningRate: 0,
    spotTotalOperations: 4,
    spotIcEvents: 4,
    odIcEvents: 20,
    spotMortalityRate: null,
    odPrice: 27.447,
    spotPrice: 27.273625,
    avgVcpu: 96,
    avgMemoryGb: 1152,
    name: 'p4de.24xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus',
    availabilityZones: ['1', '3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 8,
    avgMemoryGb: 56,
    name: 'Standard_NC8as_T4_v3',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az3'],
    gpuType: 'T4g',
    gpuCount: 2,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 1,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 2.744,
    spotPrice: 0.351,
    avgVcpu: 64,
    avgMemoryGb: 128,
    name: 'g5g.metal',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus2',
    availabilityZones: ['3'],
    gpuType: 'A10',
    gpuCount: 1,
    gpuMemoryMib: 4096,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 4,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 6,
    avgMemoryGb: 55,
    name: 'Standard_NV6ads_A10_v5',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 7,
    spotIcEvents: 7,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 9.778999999999998,
    spotPrice: 2.777142857142857,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g5.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az5', 'use1-az1'],
    gpuType: 'T4',
    gpuCount: 4,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 3,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 3.9120000000000004,
    spotPrice: 1.3143333333333334,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g4dn.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'L40S',
    gpuCount: 4,
    gpuMemoryMib: 45776,
    odProvisioningRate: 0.9789548356585481,
    odTotalOperations: 4229,
    spotProvisioningRate: 0.303030303030303,
    spotTotalOperations: 99,
    spotIcEvents: 69,
    odIcEvents: 89,
    spotMortalityRate: null,
    odPrice: 15.065999999999999,
    spotPrice: 5.8116666666666665,
    avgVcpu: 96,
    avgMemoryGb: 768,
    name: 'g6e.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1', 'euc1-az2', 'euc1-az3'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 0.5,
    odTotalOperations: 6,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 3,
    spotMortalityRate: null,
    odPrice: 3.757,
    spotPrice: 1.3713333333333333,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'g6e.4xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus2',
    availabilityZones: ['3'],
    gpuType: 'A10',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 7,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 12,
    avgMemoryGb: 110,
    name: 'Standard_NV12ads_A10_v5',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus2',
    availabilityZones: ['2'],
    gpuType: 'Radeon Instinct MI25',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 16,
    avgMemoryGb: 56,
    name: 'Standard_NV16as_v4',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-north-1',
    availabilityZones: ['eun1-az2', 'eun1-az3'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 28,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.067,
    spotPrice: 0.413,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g5.xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus',
    availabilityZones: ['1', '3', '2'],
    gpuType: 'T4',
    gpuCount: 4,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0.75,
    spotTotalOperations: 4,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 64,
    avgMemoryGb: 440,
    name: 'Standard_NC64as_T4_v3',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 4,
    spotIcEvents: 4,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 4.096,
    spotPrice: 1.322,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g5.16xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east4',
    availabilityZones: ['2270'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 124,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 0.851,
    spotPrice: 0.34,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g2-standard-8',
  },
  {
    cloud: Cloud.azure,
    region: 'northeurope',
    availabilityZones: ['1', '3', '2'],
    gpuType: 'T4',
    gpuCount: 4,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 9,
    spotProvisioningRate: 0.3589743589743589,
    spotTotalOperations: 39,
    spotIcEvents: 25,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 64,
    avgMemoryGb: 440,
    name: 'Standard_NC64as_T4_v3',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-north-1',
    availabilityZones: ['eun1-az2', 'eun1-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 28,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.6329999999999998,
    spotPrice: 0.3175,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'gr6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'L4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.7755102040816326,
    odTotalOperations: 98,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 22,
    spotMortalityRate: null,
    odPrice: 6.675,
    spotPrice: 2.5900000000000003,
    avgVcpu: 96,
    avgMemoryGb: 384,
    name: 'g6.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'L4',
    gpuCount: 500,
    gpuMemoryMib: 11444,
    odProvisioningRate: 0,
    odTotalOperations: 9,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 9,
    spotMortalityRate: null,
    odPrice: 1.141,
    spotPrice: 0.8975,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g6f.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az3'],
    gpuType: 'T4',
    gpuCount: 4,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 4.362,
    spotPrice: 1.803,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g4dn.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-2',
    availabilityZones: ['euw2-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 5.092,
    spotPrice: 0.679,
    avgVcpu: 64,
    avgMemoryGb: 256,
    name: 'g4dn.16xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az3'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 4,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.342,
    spotPrice: 0.625,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g4dn.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'A100',
    gpuCount: 8,
    gpuMemoryMib: 40960,
    odProvisioningRate: 0.9978986078276858,
    odTotalOperations: 3807,
    spotProvisioningRate: 0.9901840490797545,
    spotTotalOperations: 815,
    spotIcEvents: 8,
    odIcEvents: 8,
    spotMortalityRate: null,
    odPrice: 25.563,
    spotPrice: 10.085333333333333,
    avgVcpu: 96,
    avgMemoryGb: 1152,
    name: 'p4d.24xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-west-2',
    availabilityZones: ['usw2-az2'],
    gpuType: 'RTX PRO Server 6000',
    gpuCount: 1,
    gpuMemoryMib: 98304,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: 1.094,
    avgVcpu: 8,
    avgMemoryGb: 64,
    name: 'g7e.2xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus2',
    availabilityZones: ['2'],
    gpuType: 'M60',
    gpuCount: 1,
    gpuMemoryMib: 8192,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 3,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 12,
    avgMemoryGb: 112,
    name: 'Standard_NV12s_v3',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east4',
    availabilityZones: ['2270'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 123,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 0.997,
    spotPrice: 0.399,
    avgVcpu: 12,
    avgMemoryGb: 48,
    name: 'g2-standard-12',
  },
  {
    cloud: Cloud.gcp,
    region: 'us-east4',
    availabilityZones: ['2270', '2272'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.9726027397260274,
    odTotalOperations: 146,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 4,
    spotMortalityRate: null,
    odPrice: 0.705,
    spotPrice: 0.282,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g2-standard-4',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.8873239436619719,
    odTotalOperations: 71,
    spotProvisioningRate: 0,
    spotTotalOperations: 5,
    spotIcEvents: 5,
    odIcEvents: 8,
    spotMortalityRate: null,
    odPrice: 2.014,
    spotPrice: 0.99484,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g6.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-north-1',
    availabilityZones: ['eun1-az2', 'eun1-az1'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 1,
    odTotalOperations: 28,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.974,
    spotPrice: 0.842,
    avgVcpu: 4,
    avgMemoryGb: 32,
    name: 'g6e.xlarge',
  },
  {
    cloud: Cloud.azure,
    region: 'eastus',
    availabilityZones: ['3'],
    gpuType: 'V100',
    gpuCount: 2,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 1,
    spotTotalOperations: 3,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: null,
    spotPrice: null,
    avgVcpu: 12,
    avgMemoryGb: 224,
    name: 'Standard_NC12s_v3',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'L4',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.5588235294117647,
    odTotalOperations: 34,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 15,
    spotMortalityRate: null,
    odPrice: 4.602,
    spotPrice: 2.1641923076923075,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g6.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'ap-south-1',
    availabilityZones: ['aps1-az1', 'aps1-az3'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 27,
    spotIcEvents: 27,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.589,
    spotPrice: 0.363,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'L4',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.9987630323378689,
    odTotalOperations: 5659,
    spotProvisioningRate: 0.9927760577915377,
    spotTotalOperations: 969,
    spotIcEvents: 7,
    odIcEvents: 7,
    spotMortalityRate: null,
    odPrice: 13.350000000000001,
    spotPrice: 5.846,
    avgVcpu: 192,
    avgMemoryGb: 768,
    name: 'g6.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1'],
    gpuType: 'T4g',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.716,
    spotPrice: 0.389,
    avgVcpu: 32,
    avgMemoryGb: 64,
    name: 'g5g.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.7938931297709924,
    odTotalOperations: 131,
    spotProvisioningRate: 0,
    spotTotalOperations: 6,
    spotIcEvents: 6,
    odIcEvents: 27,
    spotMortalityRate: null,
    odPrice: 5.672,
    spotPrice: 3.0230333333333332,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g5.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-2',
    availabilityZones: ['euw2-az3', 'euw2-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.5,
    odTotalOperations: 2,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 1,
    spotMortalityRate: null,
    odPrice: 1.68,
    spotPrice: 0.628,
    avgVcpu: 16,
    avgMemoryGb: 64,
    name: 'g6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1'],
    gpuType: 'T4g',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 1,
    spotIcEvents: 1,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 0.696,
    spotPrice: 0.177,
    avgVcpu: 8,
    avgMemoryGb: 16,
    name: 'g5g.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1', 'euc1-az2', 'euc1-az3'],
    gpuType: 'A10G',
    gpuCount: 4,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.33333333333333337,
    odTotalOperations: 3,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 2,
    spotMortalityRate: null,
    odPrice: 7.093,
    spotPrice: 4.119666666666666,
    avgVcpu: 48,
    avgMemoryGb: 192,
    name: 'g5.12xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'sa-east-1',
    availabilityZones: ['sae1-az2'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: null,
    odTotalOperations: 0,
    spotProvisioningRate: 0,
    spotTotalOperations: 3,
    spotIcEvents: 3,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 2.616,
    spotPrice: 0.287,
    avgVcpu: 16,
    avgMemoryGb: 128,
    name: 'gr6.4xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-2',
    availabilityZones: ['euw2-az3', 'euw2-az2', 'euw2-az1'],
    gpuType: 'L4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 3,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 3,
    spotMortalityRate: null,
    odPrice: 1.241,
    spotPrice: 0.6066666666666667,
    avgVcpu: 8,
    avgMemoryGb: 32,
    name: 'g6.2xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az3'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 2,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 1.123,
    spotPrice: 0.56,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g5.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az2', 'euw1-az3', 'euw1-az1'],
    gpuType: 'T4',
    gpuCount: 1,
    gpuMemoryMib: 16384,
    odProvisioningRate: 1,
    odTotalOperations: 57,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 0.5870000000000001,
    spotPrice: 0.3028571428571428,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g4dn.xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-west-1',
    availabilityZones: ['euw1-az2', 'euw1-az3', 'euw1-az1'],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 1,
    odTotalOperations: 72,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 2.7329999999999997,
    spotPrice: 1.1906415094339622,
    avgVcpu: 32,
    avgMemoryGb: 128,
    name: 'g5.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'eu-central-1',
    availabilityZones: ['euc1-az1'],
    gpuType: 'L40S',
    gpuCount: 1,
    gpuMemoryMib: 45776,
    odProvisioningRate: 1,
    odTotalOperations: 1,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 0,
    spotMortalityRate: null,
    odPrice: 5.663,
    spotPrice: 1.763,
    avgVcpu: 32,
    avgMemoryGb: 256,
    name: 'g6e.8xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az1'],
    gpuType: 'A10G',
    gpuCount: 8,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.9984160506863781,
    odTotalOperations: 5682,
    spotProvisioningRate: 0.9855907780979827,
    spotTotalOperations: 347,
    spotIcEvents: 5,
    odIcEvents: 9,
    spotMortalityRate: null,
    odPrice: 16.288,
    spotPrice: 7.169666666666667,
    avgVcpu: 192,
    avgMemoryGb: 768,
    name: 'g5.48xlarge',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: [
      'use1-az5',
      'use1-az4',
      'use1-az1',
      'use1-az2',
      'use1-az6',
    ],
    gpuType: 'A10G',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0.98,
    odTotalOperations: 50,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 1,
    spotMortalityRate: null,
    odPrice: 1.006,
    spotPrice: 0.4461176470588235,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g5.xlarge',
  },
  {
    cloud: Cloud.gcp,
    region: 'europe-west4',
    availabilityZones: ['2340', '2341', '2342'],
    gpuType: 'nvidia-l4',
    gpuCount: 1,
    gpuMemoryMib: 22888,
    odProvisioningRate: 0,
    odTotalOperations: 4,
    spotProvisioningRate: null,
    spotTotalOperations: 0,
    spotIcEvents: 0,
    odIcEvents: 4,
    spotMortalityRate: null,
    odPrice: 0.743,
    spotPrice: 0.34,
    avgVcpu: 4,
    avgMemoryGb: 16,
    name: 'g2-standard-4',
  },
  {
    cloud: Cloud.aws,
    region: 'us-east-1',
    availabilityZones: ['use1-az2', 'use1-az4', 'use1-az6', 'use1-az1'],
    gpuType: 'L40S',
    gpuCount: 4,
    gpuMemoryMib: 45776,
    odProvisioningRate: 0.9893503727369543,
    odTotalOperations: 4695,
    spotProvisioningRate: 0.9378330373001776,
    spotTotalOperations: 563,
    spotIcEvents: 35,
    odIcEvents: 50,
    spotMortalityRate: null,
    odPrice: 10.493,
    spotPrice: 5.2217346938775515,
    avgVcpu: 48,
    avgMemoryGb: 384,
    name: 'g6e.12xlarge',
  },
];
